import { DomainNode } from '@store/services/nodes/types';
import { IDomain } from '@store/services/projects/types';

export const findWideDomain = (domains: IDomain[]) => {
  return domains.find(({ level, num }) => level === 0 && num === 0);
};

export const checkDomainFilter = (
  filterDomainIds: string[],
  domainNodes: DomainNode[] = [],
) =>
  filterDomainIds.some((domainId) =>
    domainNodes.some(
      ({ domain_id }: { domain_id: string }) => domain_id === domainId,
    ),
  );
